export const ROUTES = {
    HOME: '/',
    LOGIN: '/login',
    LOGOUT: '/logout',
    REGISTER: '/register',
    FORGOT_PASSWORD: '/forgot-password',
    RESET_PASSWORD: '/reset-password',
    SETUP_DEMO: '/setup-demo',
    ACCEPT_INVITATION: '/accept-invitation',
    VERIFY_EMAIL: '/verify-email',

    PRODUCT_FEATURES: '/product-features',
    SERVICES: '/services',
    PRICING: '/pricing',
    ABOUT: '/about',
    TRIAL: '/trial',
    SUPPORT: '/support',
    CONTACT: '/contact',
    SUCCESS: '/success',

    SUBMIT_FORM: '/submit-form',
    STRIPE_SUCCESS: '/stripe-success',
    STRIPE_CANCEL: '/stripe-cancel',
    TARGET_REPORT: '/target-report',

    NEW_BUSINESS: '/new-business',

    DASHBOARD: '/dashboard',
    DASHBOARD_ROOT: '/dashboard/2hq',

    ADMIN: '/dashboard/admin',
    ADMIN_USERS: '/dashboard/admin/users',
    ADMIN_CREDIT_AUDIT: '/dashboard/admin/credit-audit',
    ADMIN_PROMPTS: '/dashboard/admin/prompts',
    ADMIN_STRUCTURES: '/dashboard/admin/structures',
    ADMIN_TEMPLATES_NEW: '/dashboard/admin/templates/new',
    ADMIN_ENTITIES: '/dashboard/admin/entities',
    ADMIN_ENTITIES_NEW: '/dashboard/admin/entities/new',
    ADMIN_WIZARD_CATEGORIES: '/dashboard/admin/wizard-categories',
    ADMIN_WIZARD_CATEGORIES_NEW: '/dashboard/admin/wizard-categories/new',
    ADMIN_SEQUENCES: '/dashboard/admin/sequences',
    ADMIN_SEQUENCES_NEW: '/dashboard/admin/sequences/new',
    ADMIN_WIZARD_FORMS: '/dashboard/admin/wizard-forms',
    ADMIN_WIZARD_FORMS_BUILDER: '/dashboard/admin/wizard-forms/wizard-form-builder',
    ADMIN_BUNDLES: '/dashboard/admin/bundles',
    ADMIN_BUNDLES_NEW: '/dashboard/admin/bundles/new',
    ADMIN_DATASET_TEMPLATES: '/dashboard/admin/dataset-templates',
    ADMIN_DATASET_TEMPLATES_NEW: '/dashboard/admin/dataset-templates/new',
    ADMIN_COMZONE_CODES: '/dashboard/admin/comzone-codes',
    ADMIN_COMZONE_CODES_NEW: '/dashboard/admin/comzone-codes/new',
    ADMIN_CLIENT_PORTALS: '/dashboard/admin/client-portals',
    ADMIN_INTERVIEWS: '/dashboard/admin/interviews',
    ADMIN_DELIVERABLE_TEMPLATES: '/dashboard/admin/deliverable-templates',
    ADMIN_MOBILE_PACKAGES: '/dashboard/admin/mobile-packages',
    ADMIN_MOBILE_USERS: '/dashboard/admin/mobile-users',
    ADMIN_MOBILE_BUNDLES: '/dashboard/admin/mobile-bundles',
    ADMIN_CAMPAIGN_SCENARIOS: '/dashboard/admin/campaign-scenarios',

    BRAND_GUIDE: '/dashboard/brand-guide',
    BRAND_GUIDE_CREATE: '/dashboard/brand-guide/create',
    PROJECTS: '/dashboard/projects',
    DOCUMENTS: '/dashboard/documents',
    NODES: '/dashboard/nodes',
    FORMS: '/dashboard/forms',
    FORMS_FORM: '/dashboard/forms/form',
    TRAINING: '/dashboard/training',
    BRAND_VOICE: '/dashboard/brand-voice',
    TEMPLATES: '/dashboard/templates',
    TEMPLATES_CREATE_CUSTOM: '/dashboard/templates/create-custom',
    TOOLS: '/dashboard/tools',
    MEDIA: '/dashboard/media',
    MOOD_BOARDS: '/dashboard/mood-boards',
    MOOD_BOARDS_CUSTOM: '/dashboard/mood-boards/custom',
    MOOD_BOARDS_DEFAULT: '/dashboard/mood-boards/default',
    FLOWS: '/dashboard/flows',
    FLOWS_STORE: '/dashboard/flows/store',
    FLOWS_STORE_CART: '/dashboard/flows/store/cart',
    FLOWS_STORE_CHECKOUT: '/dashboard/flows/store/checkout',
    TWO_HQ: '/dashboard/2hq',
    INTERVIEW_COACH: '/dashboard/interview',
    PROMPTS: '/dashboard/prompts',
    SCRIPTS: '/dashboard/scripts',
    SHARED: '/dashboard/shared',
    SUPPORT_DASHBOARD: '/dashboard/support',

    SETTINGS: '/dashboard/settings',
    SETTINGS_PERSONAL: '/dashboard/settings/personal',
    SETTINGS_BUSINESS: '/dashboard/settings/business',
    SETTINGS_WORKSPACES: '/dashboard/settings/workspaces',
    SETTINGS_INTEGRATIONS: '/dashboard/settings/integrations',
    SETTINGS_TWO_HQ: '/dashboard/settings/2hq',

    FLOWS_F1_REPORT: '/dashboard/flows/f1/report',
    FLOWS_F2_REPORT: '/dashboard/flows/f2/report',
    FLOWS_F3_REPORT: '/dashboard/flows/f3/report',
    FLOWS_F4_REPORT: '/dashboard/flows/f4/report',
    FLOWS_F6_REPORT: '/dashboard/flows/f6/report',
    FLOWS_F7_REPORT: '/dashboard/flows/f7/report',
    FLOWS_F8_REPORT: '/dashboard/flows/f8/report',
    FLOWS_F9_REPORT: '/dashboard/flows/f9/report',
    FLOWS_F10_REPORT: '/dashboard/flows/f10/report',
    FLOWS_F11_REPORT: '/dashboard/flows/f11/report',
    FLOWS_F12_REPORT: '/dashboard/flows/f12/report',
    FLOWS_F13_REPORT: '/dashboard/flows/f13/report',
    FLOWS_F14_REPORT: '/dashboard/flows/f14/report',
    FLOWS_F15_REPORT: '/dashboard/flows/f15/report',
    FLOWS_F16_REPORT: '/dashboard/flows/f16/report',
    FLOWS_F17_REPORT: '/dashboard/flows/f17/report',
    FLOWS_F18_REPORT: '/dashboard/flows/f18/report',
    FLOWS_F19_REPORT: '/dashboard/flows/f19/report',
    FLOWS_F20_REPORT: '/dashboard/flows/f20/report',
    CONTENT_SHEETS: '/dashboard/content-sheets',
    PERSUASION_LAB: '/dashboard/persuasion-lab',
    PERSUASION_LAB_FOUNDATIONS: '/dashboard/brand-strategy/foundations',
    PERSUASION_LAB_STORIES: '/dashboard/persuasion-lab/stories',
    PERSUASION_LAB_RESEARCH: '/dashboard/persuasion-lab/research',
    PERSUASION_LAB_ARGUMENT_BUILDER: '/dashboard/persuasion-lab/argument-builder',
    PERSUASION_LAB_CREATIVE_CONTEXT: '/dashboard/persuasion-lab/creative-context',
} as const

export const DYNAMIC_ROUTES = {
    magicLogin: (token: string) => `/magic/${token}`,

    magicExecution: (slug: string, id: string) => `/magic-execution/${slug}/${id}`,

    adminStructure: (structure: string) => `/dashboard/admin/structures/${structure}`,
    adminEntity: (entity: string) => `/dashboard/admin/entities/${entity}`,
    adminWizardCategory: (category: string) => `/dashboard/admin/wizard-categories/${category}`,
    adminSequence: (slug: string) => `/dashboard/admin/sequences/${slug}`,
    adminWizardForm: (id: string) => `/dashboard/admin/wizard-forms/${id}`,
    adminBundle: (bundleId: string) => `/dashboard/admin/bundles/${bundleId}`,
    adminDatasetTemplate: (template: string) => `/dashboard/admin/dataset-templates/${template}`,
    adminComzoneCode: (id: string) => `/dashboard/admin/comzone-codes/${id}`,

    brandGuide: (id: string) => `/dashboard/brand-guide/${id}`,
    wizard: (id: string) => `/dashboard/wizards/${id}`,
    userWizard: (id: string) => `/dashboard/user-wizards/${id}`,
    documentFolder: (folder: string) => `/dashboard/document/${folder}`,
    nodeFolder: (folder: string) => `/dashboard/node/${folder}`,
    file: (file: string) => `/dashboard/file/${file}`,
    fileWithType: (type: string, file: string) => `/dashboard/${type}/file/${file}`,
    editor: (file: string) => `/dashboard/editor/${file}`,
    formSubmissions: (form: string) => `/dashboard/forms/${form}/submissions`,
    formSubmission: (form: string, id: string) => `/dashboard/forms/${form}/submissions/${id}`,
    templatesCustom: (id: string) => `/dashboard/templates/custom/${id}`,
    mediaFolder: (folder: string) => `/dashboard/media/${folder}`,
    moodBoardsCustom: (id: string) => `/dashboard/mood-boards/custom/${id}`,
    flowExecution: (slug: string, id: string) => `/dashboard/flows/${slug}/${id}`,
    flowStore: (id: string) => `/dashboard/flows/store/${id}`,
    flowMyFlows: (id: string) => `/dashboard/flows/my-flows/${id}`,
    sharedFolder: (folder: string) => `/dashboard/shared/${folder}`,

    flowF5Report: (flowName: string, id: string) => `/dashboard/flows/f5/${flowName}/${id}/report`,

    persuasionLabRun: (runId: string) => `/dashboard/persuasion-lab/${runId}`,
    persuasionLabRunCreativeContext: (runId: string) => `/dashboard/persuasion-lab/${runId}/creative-context`,
} as const

export type RouteKey = keyof typeof ROUTES
export type RouteValue = (typeof ROUTES)[RouteKey]
